import axios from 'axios'

export const state = () => ({
  maintenanceInfo: {
    is_active: false,
    message: ''
  }
})

export const mutations = {
  setMaintenanceInfo(state, info) {
    state.maintenanceInfo = info
  }
}

export const actions = {
  async checkMaintenance({ commit }) {
    try {
      const response = await axios.get(`${process.env.MAIN_API}/aec/maintenance`)
      if (response.data.status === 'success' && response.data.result) {
        commit('setMaintenanceInfo', response.data.result)
        return response.data.result
      }
    } catch (error) {
      console.error('Error checking maintenance status:', error.message)
      commit('setMaintenanceInfo', {
        is_active: false,
        message: ''
      })
    }
    return null
  }
}

export const getters = {
  maintenanceInfo: state => state.maintenanceInfo,
  isMaintenanceMode: state => state.maintenanceInfo.is_active
} 